import moment from 'moment';

export const CHAT_USER_TYPE = {
    STAFF: 'Staff',
    CLIENT: 'Client',
};

export const MESSAGE_PAGE_LIMIT = 50;

/** SYSTEM messages are notices about the chat ("Jane was removed") — shown centered, not as a bubble. */
export const MESSAGE_TYPE = {
    USER: 'USER',
    SYSTEM: 'SYSTEM',
};

/** Group chats are managed (members removed, chat deleted) by their creator or a Super admin — same rule as the API. */
export const canManageGroupChat = (chat, currentUserId, isSuperAdmin) =>
    !!chat?.isGroup && (isSuperAdmin || !!chat?.participants?.some((p) => p.userId === currentUserId && p.isOwner));

export const renderTimeAgo = (date) => {
    if (!date) return '';
    const now = moment();
    const msgDate = moment(date);
    const diffMinutes = now.diff(msgDate, 'minutes');
    const diffHours = now.diff(msgDate, 'hours');
    const diffDays = now.diff(msgDate, 'days');

    if (diffMinutes < 1) return 'Just now';
    if (diffMinutes < 60) return `${diffMinutes} min ago`;
    if (diffHours < 24) return `${diffHours} hr ago`;
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    return msgDate.format('MM/DD/YYYY');
};

export const groupMessagesByDate = (messages) => {
    const groups = {};
    messages.forEach((msg) => {
        const dateKey = moment(msg.createdAt).format('YYYY-MM-DD');
        if (!groups[dateKey]) {
            groups[dateKey] = [];
        }
        groups[dateKey].push(msg);
    });
    return groups;
};

export const formatDateSeparator = (dateKey) => {
    const date = moment(dateKey);
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'day').startOf('day');

    if (date.isSame(today, 'day')) return 'Today';
    if (date.isSame(yesterday, 'day')) return 'Yesterday';
    return date.format('MMMM D, YYYY');
};

export const isImageFile = (fileType) => {
    if (!fileType) return false;
    if (fileType.startsWith('image/')) return true;
    const ext = fileType.toLowerCase().replace('.', '');
    return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'].includes(ext);
};

export const formatFileSize = (bytes) => {
    if (!bytes) return '';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const getChatName = (chat, currentUserId) => {
    if (!chat) return '';
    if (chat.isGroup && chat.title) return chat.title;
    const otherParticipant = chat.participants?.find((p) => p.userId !== currentUserId);
    if (otherParticipant?.user) {
        const { firstName, lastName } = otherParticipant.user;
        // if (fullName) return fullName;
        if (firstName || lastName) return `${firstName || ''} ${lastName || ''}`.trim();
    }
    return 'Unknown User';
};

export const getChatAvatar = (chat, currentUserId) => {
    if (!chat) return null;
    // A group shows its own photo or, without one, its members' stack — never one member's photo
    if (chat.isGroup) return chat.avatarUrl || null;
    const otherParticipant = chat.participants?.find((p) => p.userId !== currentUserId);

    return otherParticipant?.user?.avatar || null;
};

export const getParticipantRole = (chat, currentUserId) => {
    if (!chat) return '';
    const otherParticipant = chat.participants?.find((p) => p.userId !== currentUserId);
    return otherParticipant?.userType || '';
};
